import React from 'react'
import Images from '../ImagesComponent/Images.js'

class ThumbnailCategory extends React.Component {
    render() {
        const { data } = this.props
        return (
            <div className="col-md-12 mt4">
                <div className="row" id="mitra-kategori-icon">
                    <h4>Kategori</h4>
                    <div className="sameheightparent">
                        <ul className="row ma5 pd1 mb5">
                            {data && data.map((item, index) => {
                                return (
                                    <a href={'/mitra/content/'+(item.the_id).toLowerCase().replace(/ /g, '-')} >
                                        <li key={index} className="pd4 sameheight">
                                            <div className="image-category-container">
                                                <Images alt="" src={item.image} style={{width:'100%'}}/>
                                            </div>
                                            <p>{item.name}</p>
                                        </li>
                                    </a>
                                )
                            })}
                            <li className="the-clear">

                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        )
    }
}

export default ThumbnailCategory